var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 65,
    width: 150,
    height: 150
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-68 -65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.586 111.269C180.028 89.4128 160.237 73.7686 138.381 76.3264 118.356 78.6699 103.238 95.6027 103.169 115.764L121.919 115.764C121.918 104.119 131.358 94.6777 143.004 94.6772 154.649 94.6767 164.09 104.117 164.091 115.762 164.091 123.023 160.355 129.774 154.203 133.63 141.506 141.398 133.724 155.175 133.625 170.059L152.375 170.059C152.495 161.627 156.96 153.853 164.184 149.502 177.191 141.384 184.355 126.498 182.586 111.269Z",
    stroke: "#FFFFFF",
    strokeWidth: 1.56252,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.405 184.491 151.405 184.491C146.937 180.013 139.685 180.006 135.207 184.474 135.202 184.479 135.196 184.485 135.191 184.491 134.143 185.542 133.309 186.787 132.734 188.156 132.137 189.57 131.832 191.091 131.839 192.627 131.83 194.156 132.136 195.67 132.737 197.077 133.906 199.825 136.101 202.009 138.856 203.163 140.27 203.76 141.79 204.066 143.325 204.062 144.854 204.07 146.369 203.764 147.775 203.164 150.51 201.996 152.689 199.817 153.856 197.081 154.457 195.675 154.763 194.16 154.756 192.631 154.762 191.096 154.457 189.575 153.859 188.161 153.286 186.791 152.452 185.544 151.405 184.491Z",
    stroke: "#FFFFFF",
    strokeWidth: 1.56252,
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/QuestionMark.96e7cf0d9ce4a7d5d18d55ea6c58c192.svg";
export { ForwardRef as ReactComponent };